// As linhas da caixa das metas (Adnéia, 03/11/2026: "quero saber tanto o ETR como o Tem em Casa
// a média... qual o valor obtido?"). A linha do ETR e a do Tem em Casa mostram duas coisas: quem
// espera agora e o obtido em 30 dias (a média de quem passou pela etapa no mês, em dias úteis).
// Sem ninguém esperando aparece "ninguém" (antes, um "—" vermelho). Sem medida ainda, "?" e
// desde quando o ELO mede.

export const COR_DA_LINHA = {
  verde: 'text-emerald-600',
  vermelho: 'text-red-600',
  cinza: 'text-muted-foreground',
};

export function linhaDaCaixa(l) {
  const ninguem = l.num === null || l.num === undefined;
  const esperando = ninguem ? 'ninguém' : l.valor;
  const corEsperando = ninguem || l.ok ? 'verde' : 'vermelho';
  if (l.obtido === undefined) return { esperando, corEsperando, temObtido: false };

  const corObtido = l.obtido_ok === null || l.obtido_ok === undefined ? 'cinza'
    : l.obtido_ok ? 'verde' : 'vermelho';
  let rodape = l.limite;
  if (l.obtido_num === null || l.obtido_num === undefined) {
    if (l.medindo_desde) rodape += ` · medindo desde ${l.medindo_desde}`;
  } else {
    rodape += ` · ${l.obtido_n} ${l.obtido_n === 1 ? 'medido' : 'medidos'}`;
    if (typeof l.obtido_de === 'number' && l.obtido_de > l.obtido_n) rodape += ` de ${l.obtido_de}`;
  }
  return { esperando, corEsperando, temObtido: true, obtido: l.obtido, corObtido, rodape };
}
